import {
  useGetPresignedUrlMutation,
  useSendFilesMutation,
  useSendMessageMutation,
} from "../../../Store/Builder/messaging.api";
import {useDispatch, useSelector} from "react-redux";
import {
  setChatToTop,
  setNewMessageInChat, setViewMessage,
} from "../../../Store/Slice/messagingSlice";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import useScrollToElement from "../../Hooks/scrollToTop";
import useGetNewChatsApi from "./getNewChatsApi";
import axios from "axios";
import showToast from "../../Hooks/toast";

const useSendMessage = () => {
  const dispatch = useDispatch();
  const [sendMessage] = useSendMessageMutation();
  const [sendFilesApi] = useSendFilesMutation();
  const [getPresignedUrl] = useGetPresignedUrlMutation();
  const scrollElementToTop = useScrollToElement();
  const create = (content, targetRef) => {
    const body = {
      body: content,
    };
    sendMessage(body)
      .unwrap()
      .then((res) => {
        dispatch(
          setNewMessageInChat({
            id: res.conversation_id,
            content: { new_message: res },
          })
        );
        dispatch(setChatToTop(res));
        dispatch(setViewMessage(res))
        scrollElementToTop(targetRef, { behavior: "smooth" });

      })
      .catch(() => {});
  };

  const sendFiles = (event, userData, type = null) => {
    dispatch(setLoader(true));
    const files = event?.target?.files;
    console.log('sendFiles', files)
    const body = new FormData();
    let body2;
    Array.from(files).forEach((item, index) => {
      body2 = item.type.split("/")[1];
    });
    if (body2 === 'vnd.openxmlformats-officedocument.wordprocessingml.document') {
      body2 = 'docx';
    }
    else if (body2 === 'vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      body2 = 'xlsx';
    }    else if (body2 === 'vnd.ms-excel') {
      body2 = 'xls';
    }
    let allowed_ext = ['jpg', 'jpeg', 'png', 'xls', 'xlsx', 'doc', 'docx', 'pdf', 'mp4', 'mov', 'csv'];
    if (!allowed_ext.includes(body2)) {
      showToast("Unsupported file extension!", "error");
      dispatch(setLoader(false));
    } else {
      getPresignedUrl({ file_extension: body2, id: userData?.id })
        .unwrap()
        .then((res) => {
          Array.from(files).forEach((item, index) => {
            body.append(
              `files[${index}][type]`,
              type === null ? item?.type?.split("/")[0] : type
            );
            body.append(`files[${index}][url]`, res?.url);
          });

          fetch(res?.url, {
            method: "PUT",
            body: files[0],
            headers: {
              "Content-Type": files[0].type,
            },
          })
            .then(() => {
              sendFilesApi({ body, id: userData?.id })
                .unwrap()
                .then((res) => {
                  dispatch(setLoader(false));
                  dispatch(
                    setNewMessageInChat({
                      id: res.conversation_id,
                      content: { new_message: res },
                    })
                  );
                })
                .catch(() => {
                  dispatch(setLoader(false));
                });
            })
            .catch((error) => {
              console.error(
                "File upload failed:",
                error.status,
                error.statusText
              );
            });
        })
        .catch(() => {
          dispatch(setLoader(false));
        });
    }

  };

  return {
    create,
    sendFiles,
  };
};

export default useSendMessage;
